// extracted by mini-css-extract-plugin
export default {"tag":"tag__-cKgf","icon-badge":"icon-badge__3n_dt","label":"label__pMakV"};